import { Center, VStack, Text, Box, Image, Portal } from '@chakra-ui/react';
import { useEffect, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';

import logoLight from '@/assets/logo/light.png';
import logoDark from '@/assets/logo/dark.png';
import { useColorModeValue } from './color-mode';

export function LoadingScreen() {
  const logo = useColorModeValue(logoLight, logoDark);
  const intl = useIntl();
  const progressMessages = useMemo(
    () => [
      intl.formatMessage({ id: '9813b95d-ee93-4a1e-bb0d-cf8303e3ce24', defaultMessage: 'Fetching home data...' }),
      intl.formatMessage({ id: 'ef791a98-7bb4-4ad4-8f9a-c6348c64e045', defaultMessage: 'Loading your preferences...' }),
      intl.formatMessage({ id: '802abfc4-dd87-4f15-811b-0e38d3be1d08', defaultMessage: 'Syncing your profile...' }),
      intl.formatMessage({ id: '1d9e1c1e-e6d5-4e5b-80b2-d4e8de2a207a', defaultMessage: 'Almost there...' }),
    ],
    [intl]
  );
  const [progressIndex, setProgressIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgressIndex((prev) => (prev + 1) % progressMessages.length);
    }, 1600);

    return () => clearInterval(interval);
  }, [progressMessages.length]);

  return (
    <Portal>
      <Center
        position="fixed"
        inset={0}
        h="100dvh"
        w="100dvw"
        bg="bg.canvas"
        zIndex="overlay"
      >
        <VStack gap={8}>
          <VStack gap={5}>
            <Box
              animationStyle="bounce"
            >
              <Image
                src={logo}
                width={64}
                alt={intl.formatMessage({ id: '635d2df8-c759-4654-8290-2a634decaab7', defaultMessage: 'CoHaven logo' })}
                objectFit="contain"
              />
            </Box>
            <Text color="fg.subtle" fontSize="sm" fontWeight="medium">
              {progressMessages[progressIndex]}
            </Text>
          </VStack>
        </VStack>
      </Center>
    </Portal>
  );
}
